import { render, staticRenderFns } from "./mendianSetParams.vue?vue&type=template&id=7ddc10e6&scoped=true&"
import script from "./mendianSetParams.vue?vue&type=script&lang=js&"
export * from "./mendianSetParams.vue?vue&type=script&lang=js&"
import style0 from "./mendianSetParams.vue?vue&type=style&index=0&id=7ddc10e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc10e6",
  null
  
)

export default component.exports